import React, { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { DashboardLayout } from "src/components/dashboard";
import { DashboardContainer } from "../dashboard/Dashboard";
import { ScaleLoader } from "react-spinners";
import { RhsHeading } from "../admin/Admin";
import AddOccupationModal from "src/components/Others/AddOccupationModal";
import CategoryTable from "src/components/Others/CategoriesTable";
import AddCategoriesModal from "src/components/Others/AddCategoriesModal";
import { useAppDispatch, useAppSelector } from "src/store";
import {
	setCategories,
	setMiscSearchField,
	useGetCategoriesQuery,
} from "src/store";

type Props = {};

const Categories = (props: Props) => {
	const dispatch = useAppDispatch();
	const { categories, searchField } = useAppSelector((state) => state.misc);
	const [open, setOpen] = useState(false);
	const handleOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);

	const { data, error, isLoading } = useGetCategoriesQuery();

	useEffect(() => {
		if (data?.payload?.data) {
			dispatch(setCategories(data.payload.data));
		}
	}, [data, dispatch]);

	  useEffect(() => {
    document.title = "Categories Page";
  }, []);

	const handleChange = (e: any) => {
		dispatch(setMiscSearchField(e.target.value));
	};

	const filteredData = categories.filter((data: any) => {
		return data.name.toLowerCase().includes(searchField.toLowerCase());
	});

	return (
		<DashboardLayout
			pageTitle='Categories'
			rhsHeading={
				<RhsHeading
					handleChange={handleChange}
					handleOpen={handleOpen}
					action='Categories'
				/>
			}
		>
			<DashboardContainer>
				<ToastContainer />
				<AddCategoriesModal
					open={open}
					fetchCategories={() => window.location.reload()}
					handleClose={handleClose}
				/>
				{isLoading ? (
					<div className='loader-container'>
						<ScaleLoader color='#7E00C4' height={50} width={8} />
					</div>
				) : (
					<CategoryTable rows={filteredData} />
				)}
			</DashboardContainer>
		</DashboardLayout>
	);
};

export default Categories;

// import React, { useEffect, useState } from "react";
// import { ToastContainer } from "react-toastify";
// import { DashboardLayout } from "src/components/dashboard";
// import { DashboardContainer } from "../dashboard/Dashboard";
// import { ScaleLoader } from "react-spinners";
// import { RhsHeading } from "../admin/Admin";
// import AddOccupationModal from "src/components/Others/AddOccupationModal";
// import CategoryTable from "src/components/Others/CategoriesTable";
// import AddCategoriesModal from "src/components/Others/AddCategoriesModal";
// import { useAppDispatch, useAppSelector } from "src/store";
// import { PaginationProps } from "src/components/ui/Pagination";
// import {
//   setCategories,
//   setMiscSearchField,
//   useGetCategoriesQuery,
// } from "src/store";

// type Props = {};

// const Categories = (props: Props) => {
//   const dispatch = useAppDispatch();
//   const { categories, searchField } = useAppSelector((state) => state.misc);
//   const [open, setOpen] = useState(false);
//   const handleOpen = () => setOpen(true);
//   const handleClose = () => setOpen(false);
//   const [Ppage, setPage] = useState(1);

//   const [paginationData, setPaginationData] = useState<PaginationProps>({
//     page: 0,
//     pageSize: 0,
//     total: 0,
//     totalPages: 0,
//   });

//   const { data, error, isLoading } = useGetCategoriesQuery({
//     page: Ppage,
//     limit: 1,
//   });

//   useEffect(() => {
//     if (data?.payload?.data) {
//       dispatch(setCategories(data.payload.data));
//     }
//     if (data?.payload?.pagination) {
//       setPaginationData(data.payload.pagination);
//     }
//   }, [data, dispatch]);

//   const handleChange = (e: any) => {
//     dispatch(setMiscSearchField(e.target.value));
//   };

//   const filteredData = categories.filter((data: any) => {
//     return data.name.toLowerCase().includes(searchField.toLowerCase());
//   });

//   return (
//     <DashboardLayout
//       pageTitle="Categories"
//       rhsHeading={
//         <RhsHeading
//           handleChange={handleChange}
//           handleOpen={handleOpen}
//           action="Categories"
//         />
//       }
//     >
//       <DashboardContainer>
//         <ToastContainer />
//         <AddCategoriesModal
//           open={open}
//           fetchCategories={() => window.location.reload()}
//           handleClose={handleClose}
//         />
//         {isLoading ? (
//           <div className="loader-container">
//             <ScaleLoader color="#7E00C4" height={50} width={8} />
//           </div>
//         ) : (
//           <CategoryTable
//             rows={filteredData}
//             Ppage={Ppage}
//             setPage={setPage}
//             paginationData={paginationData}
//           />
//         )}
//       </DashboardContainer>
//     </DashboardLayout>
//   );
// };

// export default Categories;
